<template>
  <div>
    <Doughnut v-if="loaded" :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />
    <b-modal id="enrollment-status" size="xl" hide-footer header-bg-variant="primary" header-text-variant="light"
      :title="modalTitle">
      <b-table hover sticky-header no-border-collapse head-variant="light" striped :items="enrollmentsStatus"
        :fields="modalTableLabels" :busy="modalTableBusy">
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando...</strong>
          </div>
        </template>
        <template #cell(x_student_id)="data">
          <span v-if="data.item.x_status === 'active'">
            <b-icon icon='check-circle-fill' variant="success" title="Cursando"></b-icon>
          </span>
          <span v-if="data.item.x_status === 'draft'">
            <b-icon icon='exclamation-circle-fill' variant="warning" title="Borrador"></b-icon>
          </span>
          <span v-if="data.item.x_status === 'canceled'">
            <b-icon icon='x-circle-fill' variant="danger" title="Cancelada"></b-icon>
          </span>
          <span v-if="data.item.x_student_id" class="ml-1">{{ data.item.x_student_id[1] }}</span>
        </template>
        <template #cell(x_class_id)="data">
          <span v-if="data.item.x_class_id">{{ data.item.x_class_id[1] }}</span>
        </template>
        <template #cell(x_invoice_id)="data">
          <span v-if="data.item.x_invoice_id">{{ data.item.x_invoice_id[0] }}</span>
        </template>
        <template #cell(write_date)="data">
          <span v-if="data.item.write_date">{{ data.item.write_date }}</span>
        </template>
        <template #cell(x_sale_order_id)="data">
          <span v-if="data.item.x_sale_order_id">{{ data.item.x_sale_order_id[1] }}</span>
        </template>
      </b-table>
      <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Cerrar</b-button>
    </b-modal>
  </div>
</template>

<script>
import { EnrollmentsService } from '@/services/enrollments.service'
import { Doughnut } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)
export default {
  name: 'EnrollmentStatus',
  components: {
    Doughnut
  },
  props: {
    statusCounts: {
      type: Object
    },
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => { }
    },
    plugins: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      enrollmentsStatus: [],
      modalTitle: '',
      modalTableBusy: true,
      modalTableLabels: [
        { key: 'x_student_id', label: 'Alumno/a', sortable: true },
        { key: 'x_class_id', label: 'Clase' },
        { key: 'x_invoice_id', label: 'ID Factura' },
        { key: 'write_date', label: 'Fecha Modificación', sortable: true },
        { key: 'x_sale_order_id', label: 'ID Orden de Venta' }
      ],
      loaded: false,
      chartData: {
        labels: [],
        status: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        events: ['click'],
        onClick: this.handle
      }
    }
  },

  async created () {
    // this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
  },
  async mounted () {
    this.loaded = false
    try {
      this.enrollments = await EnrollmentsService.list({ x_year_id: this.year.id }, ['id', 'x_name', 'x_status', 'x_year'])

      // Count status occurrences
      const statusCounts = {}
      this.enrollments.forEach(enrollment => {
        const status = enrollment.x_status
        statusCounts[status] = (statusCounts[status] || 0) + 1
      })

      const labelsArray = []
      const count = []
      const color = []
      const status = []

      for (const key in statusCounts) {
        if (key === 'active') {
          labelsArray.push('Cursando')
          count.push(statusCounts[key])
          color.push('#048A81')
          status.push(key)
        } else if (key === 'canceled') {
          labelsArray.push('Cancelado')
          count.push(statusCounts[key])
          color.push('#E76F51')
          status.push(key)
        } else if (key === 'draft') {
          labelsArray.push('Borrador')
          count.push(statusCounts[key])
          color.push('#F4A261')
          status.push(key)
        }
      }
      // console.log(statusData)
      this.chartData.labels = labelsArray
      this.chartData.datasets[0].data = count
      this.chartData.datasets[0].backgroundColor = color
      this.chartData.status = status
      this.loaded = true
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    async handle (event, elements) {
      this.modalTableBusy = true
      this.modalTitle = 'Cargando Datos... '
      const clickedElement = elements[0]
      const datasetIndex = clickedElement.index
      const statusLabel = this.chartData.status[datasetIndex]
      this.$bvModal.show('enrollment-status')

      try {
        this.enrollmentsStatus = await EnrollmentsService.list({ x_year_id: this.year.id, x_status: statusLabel }, ['id', 'x_student_id', 'x_status', 'x_class_id', 'x_year', 'x_invoice_id', 'x_sale_order_id', 'write_date'])
        console.log(this.enrollmentsStatus)
        this.modalTitle = `Inscripciones en estado ${this.chartData.labels[datasetIndex]} `
        this.modalTableBusy = false
      } catch (error) {
        console.log(error)
      }
    },
    hideModal () {
      this.$bvModal.hide('enrollment-status')
    }
  }
}
</script>
